export const DISCOVER_ORIGIN = "https://mutinyapp.gg";

export type DiscoverMessage =
  | { type: "init" }
  | { type: "applyTheme" }
  | { type: "path"; path: string }
  | { type: "navigate"; url: string };

export function parseDiscoverMessage(
  origin: string,
  raw: unknown,
): DiscoverMessage | undefined {
  if (origin !== DISCOVER_ORIGIN || typeof raw !== "string") return;

  let value: unknown;
  try {
    value = JSON.parse(raw);
  } catch {
    return;
  }

  if (!isRecord(value) || value.source !== "discover") return;

  switch (value.type) {
    case "init":
      return { type: "init" };
    case "applyTheme":
      return { type: "applyTheme" };
    case "path": {
      if (typeof value.path !== "string" || !value.path) return;
      const path = value.path.endsWith("?")
        ? value.path.slice(0, -1)
        : value.path;
      return path ? { type: "path", path } : undefined;
    }
    case "navigate": {
      if (typeof value.url !== "string") return;

      let target: URL;
      try {
        target = new URL(value.url);
      } catch {
        return;
      }

      if (target.origin !== DISCOVER_ORIGIN) return;
      return { type: "navigate", url: target.href };
    }
    default:
      return;
  }
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
